const initPasswordToggle = () => {
  document.querySelectorAll('[data-password-toggle]').forEach(button => {
    button.addEventListener('click', () => {
      const input = button.closest('.relative').querySelector('[data-password-input]');
      const isHidden = input.type === 'password';
      input.type = isHidden ? 'text' : 'password';
      button.querySelector('.eye-icon').classList.toggle('hidden', isHidden);
      button.querySelector('.eye-off-icon').classList.toggle('hidden', !isHidden);
    });
  });
};

const initAccountLogin = () => {
  // Initialize password toggle
  initPasswordToggle();

  const recoverPasswordBtn = document.querySelector('[data-recover-password-trigger]');
  if (!recoverPasswordBtn) return;
  const loginForm = document.querySelector('[data-login-form]');
  const recoverPasswordForm = document.querySelector('[data-recover-password-form]');
  const recoverCancelBtn = recoverPasswordForm.querySelector('[data-recover-password-cancel]');

  const showRecoverForm = () => {
    loginForm.classList.add('hidden');
    recoverPasswordForm.classList.remove('hidden');
  };

  const toggleForms = () => {
    loginForm.classList.toggle('hidden');
    recoverPasswordForm.classList.toggle('hidden');
    window.location.hash === '#recover' ? history.replaceState(null, '', window.location.pathname + window.location.search) : window.location.hash = '#recover';
    recoverCancelBtn.addEventListener('click', toggleForms, { once: true });
  };

  if (window.location.hash === '#recover' || loginForm.classList.contains('hidden')) {
    showRecoverForm();
    recoverCancelBtn.addEventListener('click', toggleForms, { once: true });
  }
  recoverPasswordBtn.addEventListener('click', toggleForms);
};

export default initAccountLogin;
